import React, { FC } from 'react';
import { LinkProps } from 'react-router-dom';
import { CustomLink } from './styles';

type Props = LinkProps;

const Link: FC<Props> = (props) => <CustomLink {...props} />;

export default Link;
